module.exports = __webpack_public_path__ + "static/media/photo.989806df.svg";